import { catchError, map } from "rxjs/operators";
import { ROLE_NAMES, UserRole } from "../model/user-role";

import { Injectable } from "@angular/core";
import { AuthUser } from "@app/auth/model/auth-user";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { DbCrudHelper } from "@app/shared/services/db-crud-helper";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class UserRoleService {
    constructor(private crudHelper: DbCrudHelper) {}

    getUserRoles(authUser?: AuthUser): Observable<ClareDbCollection<UserRole>> {
        return this.crudHelper.makeRequest<UserRole[]>("GetAllRoles").pipe(
            map(roles =>
                roles.reduce((collection, r) => {
                    collection[r.id] = r;
                    return collection;
                }, {} as Record<number, UserRole>)
            ),
            catchError(DataServiceError.handleError())
        );
    }

    getCustomerRole(userRoles: ClareDbCollection<UserRole>): UserRole {
        let customerRole = null;

        for (const role in userRoles) {
            if (userRoles?.[role]?.name === ROLE_NAMES.CUSTOMER) {
                customerRole = userRoles[role];
                break;
            }
        }

        return customerRole;
    }
}
